export default {
  locale: "en",
  messages: {
    name: "Issuer",
    nif: "Nif",
    date: "Date",
    concept: "Comment",
    amount: "Amount",
    society: "Society",
    division: "Division",
    account: "Account",
    empty: " ",
    sapCode: "SAP Code",
    userRule: "User / Rule",
    businessLine: "Buisness Line",
    referenceNumber: "referenceNumber",
    expirationDate: "expirationDate",
    accountingKey: "Accounting Key",
    recArea: "Reclaiming area",
    auto: "Automatic",
    archive: "File",
    updatedDate: "Last Update",
    type: "Type",
    ceco: "CECO",
    origen: "Origen",
    sapStatus: "ESTADO SAP",
    auxAccountNumber: "Cuenta auxiliar"
  }
};
